module.exports = __webpack_public_path__ + "img/Ahad.7f3302a6.jpeg";